/* eslint-disable no-console */
import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/CountriesDef';

type ParamsType = {
  country: string;
  ddi: string;
  iso2: string;
  iso3: string;
};

const autoGenerateSuccess = (params?: ParamsType | undefined) => {
  const data = params
    ? {
        iso3: 'BRA',
        country: 'Brasil',
        countryToSave: 'Brazil',
        ddi: '55',
        iso2: 'BR',
      }
    : [
        {
          iso3: 'ARG',
          country: 'Argentina',
          countryToSave: 'Argentina',
          ddi: '54',
          iso2: 'AR',
        },
        {
          iso3: 'BRA',
          country: 'Brasil',
          countryToSave: 'Brazil',
          ddi: '55',
          iso2: 'BR',
        },
        {
          iso3: 'USA',
          country: 'Estados Unidos',
          countryToSave: 'United States of America',
          ddi: '1',
          iso2: 'US',
        },
        {
          iso3: 'ABW',
          country: 'Aruba',
          countryToSave: 'Aruba',
          ddi: '297',
          iso2: 'AW',
        },
        {
          iso3: 'AFG',
          country: 'Afeganistão',
          countryToSave: 'Afghanistan',
          ddi: '93',
          iso2: 'AF',
        },
        {
          iso3: 'AGO',
          country: 'Angola',
          countryToSave: 'Angola',
          ddi: '244',
          iso2: 'AO',
        },
        {
          iso3: 'AIA',
          country: 'Anguilla',
          countryToSave: 'Anguilla',
          ddi: '1',
          iso2: 'AI',
        },
        {
          iso3: 'ALA',
          country: 'Ilhas Åland',
          countryToSave: 'Ilhas Åland',
          ddi: '358',
          iso2: 'AX',
        },
        {
          iso3: 'ALB',
          country: 'Albânia',
          countryToSave: 'Albânia',
          ddi: '355',
          iso2: 'AL',
        },
        {
          iso3: 'AND',
          country: 'Andorra',
          countryToSave: 'Andorra',
          ddi: '376',
          iso2: 'AD',
        },
        {
          iso3: 'TWN',
          country: 'Taiwan',
          countryToSave: 'Taiwan',
          ddi: '886',
          iso2: 'TW',
        },
      ];
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data,
    },
  };
  if (params !== null) {
    validateDocumentSuccess.configRequest.params = params;
  }
  return validateDocumentSuccess;
};

const autoGenerateResponse = autoGenerateSuccess({
  country: 'Brasil',
  ddi: '55',
  iso2: 'BR',
  iso3: 'BR',
});
const autoGenerateResponseAll = autoGenerateSuccess();

const generatedSuccessMocks = [autoGenerateResponse, autoGenerateResponseAll];

const autoGenerate = (country: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          body: {},
          params: {
            country: `${country}${index}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const errorCountry = autoGenerate(MocksDef.COUNTRY);
  return [...errorCountry];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateDocumentMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default ValidateDocumentMocks;
